var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnVibration = function SvgIcnVibration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55555 14.0674C0.978517 14.0674 0.5 13.5889 0.5 13.0119V6.97407C0.5 6.39704 0.978517 5.91852 1.55555 5.91852C2.13259 5.91852 2.6111 6.39704 2.6111 6.97407V13.0119C2.6111 13.603 2.13259 14.0674 1.55555 14.0674Z",
    fill: "#57595E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77821 16.08C5.20117 16.08 4.72266 15.6014 4.72266 15.0244V4.97553C4.72266 4.3985 5.20117 3.91998 5.77821 3.91998C6.35524 3.91998 6.83376 4.3985 6.83376 4.97553V15.0244C6.83376 15.6155 6.35524 16.08 5.77821 16.08Z",
    fill: "#57595E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99989 18.0925C9.42285 18.0925 8.94434 17.614 8.94434 17.037V2.96296C8.94434 2.38593 9.42285 1.90741 9.99989 1.90741C10.5769 1.90741 11.0554 2.38593 11.0554 2.96296V17.037C11.0554 17.614 10.5769 18.0925 9.99989 18.0925Z",
    fill: "#57595E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2225 16.08C13.6455 16.08 13.167 15.6014 13.167 15.0244V4.97553C13.167 4.3985 13.6455 3.91998 14.2225 3.91998C14.7996 3.91998 15.2781 4.3985 15.2781 4.97553V15.0244C15.2781 15.6155 14.7996 16.08 14.2225 16.08Z",
    fill: "#57595E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4442 14.0674C17.8672 14.0674 17.3887 13.5889 17.3887 13.0119V6.97407C17.3887 6.39704 17.8672 5.91852 18.4442 5.91852C19.0213 5.91852 19.4998 6.39704 19.4998 6.97407V13.0119C19.4998 13.603 19.0213 14.0674 18.4442 14.0674Z",
    fill: "#57595E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnVibration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_vibration.3f41e3c8.svg";
export { ForwardRef as ReactComponent };